module.exports = __webpack_public_path__ + "media/images/lodge@2x-fc5c981bbbcff2a20d2e6f6fec6bdb1b.jpg";